<script setup lang="ts">
import Dots from './3dots_leader.svg?component';
import DiagnoseButton from './DiagnoseButton.vue';
import Logo from './logo.svg?component';
import Okaneko from './okaneko.svg?component';
import Onayami1 from './onayami1.svg?component';
import Onayami2 from './onayami2.svg?component';
import Onayami3 from './onayami3.svg?component';
import Point1Heading from './point1_heading.svg?component';
import Point1Img from './point1_img.svg?component';
import Point2Heading from './point2_heading.svg?component';
import Point2Img from './point2_img.svg?component';
import Point3Heading from './point3_heading.svg?component';
import Point3Img from './point3_img.svg?component';
import ConsultProfessional from '@/components/molecules/ConsultProfessional/ConsultProfessional.vue';
import PointsSummary from '@/components/molecules/PointsSummary/PointsSummary.vue';
import { useWindowSize } from '@vueuse/core';

const { width } = useWindowSize();
const showDots = computed(() => width.value > 1024);
const mustInsertNewLine = computed(() => width.value > 1024);
const { isMobile } = useDeviceType();
</script>

<template>
  <div :class="$style.container">
    <p :class="$style.container__heading">
      こんなこと、<wbr />相談していいのかな？
    </p>
    <div :class="[$style.container__onayami, $style.onayami]">
      <div :class="[$style.onayami__item, $style.onayamiItem]">
        <div :class="[$style.onayamiItem__balloon, $style.balloon]">
          <p :class="$style.balloon__heading">
            <span :class="$style['balloon__heading--accent']">新NISA制度</span
            >が話題だけど…
          </p>
          <p :class="$style.balloon__body">結局何を買っていいのかも</p>
          <p :class="$style.balloon__body">
            いくら投資していいのかわからないから
          </p>
          <p :class="$style.balloon__body">口座だけ作って放置してるんだよね…</p>
        </div>
        <Onayami1 :class="$style.onayamiItem__img" />
      </div>
      <div :class="[$style.onayami__item, $style.onayamiItem]">
        <div :class="[$style.onayamiItem__balloon, $style.balloon]">
          <p :class="$style.balloon__heading">
            あんまり<span :class="$style['balloon__heading--accent']"
              >貯金がない</span
            >…
          </p>
          <p :class="$style.balloon__body">他の人に比べて貯金が無いし</p>
          <p :class="$style.balloon__body">
            家計もちゃんと管理できてない。家のローンもある。
          </p>
          <p :class="$style.balloon__body">
            私みたいな人が話してもいいのかな？
          </p>
        </div>
        <Onayami2 :class="$style.onayamiItem__img" />
      </div>
      <div :class="[$style.onayami__item, $style.onayamiItem]">
        <div :class="[$style.onayamiItem__balloon, $style.balloon]">
          <p :class="$style.balloon__heading">
            <span :class="$style['balloon__heading--accent']">悩み</span
            >って言われてもなぁ…？
          </p>
          <p :class="$style.balloon__body">「お金の悩み」って言われても</p>
          <p :class="$style.balloon__body">
            今、具体的に何か相談するようなことはないよ！
          </p>
          <p :class="$style.balloon__body">
            プロと面談しても何話していいかわからない
          </p>
        </div>
        <Onayami3 :class="$style.onayamiItem__img" />
      </div>
    </div>

    <ConsultProfessional :class="$style.container__consultProfessional">
      お金のこと、<br v-if="isMobile" />誰に何を話していいかわからないから
    </ConsultProfessional>
    <Okaneko :class="$style.container__okaneko" />
    <Logo :class="$style.container__logo" />

    <div :class="[$style.container__points, $style.points]">
      <div :class="[$style.points__item, $style.pointsItem]">
        <div :class="$style.pointsItem__text">
          <Point1Heading />
          <p>
            会員登録後、あなたとコンシェルジュとのチャットが始まります。<br
              v-if="mustInsertNewLine"
            />そこで簡単な質問に答えるだけ。<br
              v-if="mustInsertNewLine"
            />あなたの家計の状態や現在のお悩みを踏まえ、まとめて診断します。気になる同世代の平均年収や平均貯蓄もわかります。
          </p>
        </div>
        <div :class="$style.pointsItem__spacer" />
        <Point1Img :class="$style.pointsItem__img" />
      </div>

      <Dots v-if="showDots" :class="$style.pointsItem__leader" />

      <div
        :class="[
          $style.points__item,
          $style.pointsItem,
          $style['pointsItem--reverse'],
        ]"
      >
        <div :class="$style.pointsItem__text">
          <Point2Heading />
          <p>
            診断結果を見て、プロがあなたのお悩みや現在の家計の問題点<br
              v-if="mustInsertNewLine"
            />またその解決方法などを丁寧にアドバイスします。<br
              v-if="mustInsertNewLine"
            />その間あなたは待つだけ。自分の今の状態に必要なことがわかります。
          </p>
        </div>
        <div :class="$style.pointsItem__spacer" />
        <Point2Img :class="$style.pointsItem__img" />
      </div>

      <Dots
        v-if="showDots"
        :class="[
          $style.pointsItem__leader,
          $style['pointsItem__leader--reverse'],
        ]"
      />

      <div :class="[$style.points__item, $style.pointsItem]">
        <div :class="$style.pointsItem__text">
          <Point3Heading />
          <p>あとはあなた専属のコンシェルジュになんでも相談し放題</p>
          <p>「今入ったほうが良い保険ってあるかな？」</p>
          <p>「投資しようと思うんだけど、どの商品がいいかな」</p>
          <p>「家を買いたいけど、ローンの最適な組み方はある？」</p>
          <p>あなたが相談したい内容に応じて、最適なプロをご紹介します。</p>
        </div>
        <div :class="$style.pointsItem__spacer" />
        <Point3Img :class="$style.pointsItem__img" />
      </div>

      <Dots v-if="showDots" :class="$style.pointsItem__leader" />

      <PointsSummary :class="$style.pointsSummary" />
    </div>
    <DiagnoseButton :class="$style.container__button" />
  </div>
</template>

<style module lang="scss">
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  padding: 32px 0 80px 0;
  @include mobile-only {
    margin-top: -24px;
    padding: 0 0 40px 0;
  }

  &__heading {
    text-align: center;
    font-size: 36px;
    font-weight: 600;
    word-break: keep-all;
    @include mobile-only {
      font-size: 26px;
    }
  }

  &__onayami {
    margin-top: 36px;
  }

  &__consultProfessional {
    margin-top: 37px;
  }

  &__okaneko {
    padding: 0 16px;
    margin-top: 80px;
  }
  &__logo {
    padding: 0 16px;
  }
  &__points {
    margin-top: 40px;
  }
  &__button {
    margin-top: 24px;
  }
}

.onayami {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 16px;
  gap: 12px;
  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }
}

.onayamiItem {
  width: 400px;
  &__balloon {
    border-radius: 20px;
    padding: 24px 0;
    position: relative;
    background-color: #f2f3f4;
    &::before {
      display: block;
      width: 20px;
      height: 20px;
      content: '';
      position: absolute;
      background-color: #f2f3f4;
      top: 100%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(45deg);
    }
  }
  &__img {
    width: 160px;
    margin-bottom: 24px;
  }
}

.balloon {
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  &__heading {
    width: 100%;
    text-align: center;
    line-height: 22px;
    margin-bottom: 16px;
    font-size: 22px;
    font-weight: 600;
  }
  &__heading--accent {
    color: $color-text-and-object-accent-primary;
  }
  &__body {
    width: 100%;
    text-align: center;
  }
}

.points {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;

  gap: 40px;
  max-width: 1024px;
  width: 100%;
}

.pointsSummary {
  width: 100%;
  &__text {
    text-align: center;
    font-size: 32px;
    font-weight: 600;
    word-break: keep-all;
    @include mobile-only {
      font-size: 24px;
    }
    &--accent {
      color: $color-text-and-object-accent-primary;
    }
  }

  &__icons {
    margin: 32px auto 0;
    display: grid;
    gap: 12px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    @media only screen and (max-width: 1024px) {
      grid-template-columns: 1fr 1fr;
      max-width: 800px;
    }
  }

  &__icon {
    &--accent {
      font-size: 30px;
      color: $color-text-and-object-accent-primary;
    }
    text-align: center;
    padding: 20px;
    font-size: 20px;
    @include mobile-only {
      font-size: 16px;
    }

    font-weight: 600;
    border-radius: 24px;
    background-color: $color-surface-accent-primary-light;
  }
}

.pointsItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media only screen and (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  &--reverse {
    flex-direction: row-reverse;
    @media only screen and (max-width: 1024px) {
      flex-direction: column;
    }
  }

  &__text {
    font-weight: 600;
    font-size: 18px;
    line-height: 34px;
    width: 100%;
    max-width: 570px;
    & > p {
      margin-left: 12px;
    }
    @media only screen and (max-width: 1024px) {
      max-width: 520px;
      font-size: 14px;
      line-height: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      & > p {
        &:nth-child(2) {
          margin-top: 16px;
        }
        margin-left: 0;
        align-self: start;
      }
    }
  }

  &__img {
    @include mobile-only {
      height: 240px;
    }
    height: 380px;
  }

  &__leader {
    width: 56px;
    &--reverse {
      transform: scaleX(-1);
    }
  }
}
</style>
